/* eslint-disable max-len,react/no-unescaped-entities */
import React from "react";

// eslint-disable-next-line no-unused-vars
import _JSXStyle from "styled-jsx/style";

import MicroDataWebPage from "components/microData/WebPage";

import Env from "app/core/environment";
import Resource from "app/core/resource";

import Image from "app/core/entities/image/Image";

import Carousel from "components/carousel/Carousel";

import styles from "../styles/main.module.scss";

class License extends React.Component {
    constructor(props) {
        super(props);

        this.carouselConfig = {
            slidesPerView: "auto",
            slideClass: "swiper-slide",
            loop: false,
            spaceBetween: 10,
            centeredSlides: false,
            autoplay: {
                delay: 4000
            },
            speed: 1250
        };

        this.stringsResource = Resource.getStrings(Env.getInstance().getLanguage());

        this.HTMLResource = Resource.getHTML(Env.getInstance().getLanguage());

        this.Resource = Resource;
    }

    /**
     * @private
     * @method _getPageInfo
     * @returns {PageInfo}
     */
    _getPageInfo() {
        // eslint-disable-next-line react/prop-types
        return this.props.options.initialData.pageInfo;
    }

    /**
     * @private
     * @method _getCertificates
     * @returns {Array}
     */
    _getCertificates() {
        return [
            {
                alt: "",
                title: "",
                src: {
                    small: "",
                    medium: "",
                    large: "https://i.apteka24.ua/legitimnost/Xerox+Scan_23122021122616.pdf",
                    original: "https://i.apteka24.ua/legitimnost/Artboard1.png"
                }
            },
            {
                alt: "",
                title: "",
                src: {
                    small: "",
                    medium: "",
                    large: "https://i.apteka24.ua/legitimnost/Xerox+Scan_23122021122625.pdf",
                    original: "https://i.apteka24.ua/legitimnost/Artboard2.png"
                }
            },
            {
                alt: "",
                title: "",
                src: {
                    small: "",
                    medium: "",
                    large: "https://i.apteka24.ua/legitimnost/Xerox+Scan_23122021122635.pdf",
                    original: "https://i.apteka24.ua/legitimnost/Artboard3.png"
                }
            },
            {
                alt: "",
                title: "",
                src: {
                    small: "",
                    medium: "",
                    large: "https://i.apteka24.ua/legitimnost/Xerox+Scan_30122021134052.pdf",
                    original: "https://i.apteka24.ua/legitimnost/Artboard+23.png"
                }
            }
        ].map((image) => new Image(image));
    }

    /**
     * @private
     * @method _renderCertificates
     * @returns {Array}
     */
    _renderCertificates() {
        return this._getCertificates().map((image, i) => (
            <div
                className="swiper-slide"
                key={i}
            >
                <a href={image.getLarge()} target="_blank">
                    <img
                        data-src={image.getOriginal()}
                        className="lazyload"
                        alt={image.getAlt()}
                    />
                </a>
            </div>
        ));
    }

    /**
     * @public
     * @method render
     * @returns {string}
     */
    render() {
        return (
            <section className="license-page">
                <MicroDataWebPage
                    pageInfo={this._getPageInfo()}
                />

                <style jsx>
                    {styles}
                </style>

                <div className="container-fluid">
                    <div className="row row--no-horizontal-sm-margins">
                        <div className="col">
                            <header className="license-page__header">
                                <h1>{this.stringsResource.legitimnost}</h1>
                            </header>
                        </div>
                    </div>

                    <div className="row row--no-horizontal-sm-margins">
                        <div className="col">
                            <div className="rounded-16 bg-white new-super-box-shadow p-24">
                                <div className="license-page__body">
                                    <p>{this.HTMLResource.license.companyRequisites}</p>
                                    <p>{this.HTMLResource.license.nationalStateRegistry}</p>
                                    <p>{this.HTMLResource.license.legalAddress}</p>
                                    <p>{this.HTMLResource.license.actualAddress}</p>

                                    <div className="mt-16">
                                        <a href="https://i.apteka24.ua/legitimnost/Frame111111295.png" target="_blank">
                                            <img
                                                className="w-100 h-100"
                                                src="https://i.apteka24.ua/legitimnost/Frame111111295.png"
                                                width="900"
                                                height="450"
                                                alt=""
                                                title=""
                                            />
                                        </a>
                                    </div>

                                    <div className="mt-16 d-flex justify-content-center">
                                        <a href="https://i.apteka24.ua/legitimnost/Frame2.png" target="_blank">
                                            <img
                                                className="w-auto h-100"
                                                src="https://i.apteka24.ua/legitimnost/Frame2.png"
                                                width="610"
                                                height="546"
                                                alt=""
                                                title=""
                                            />
                                        </a>
                                    </div>

                                    <div className="mt-16 d-flex justify-content-center">
                                        <a href="https://i.apteka24.ua/legitimnost/Frame3.png" target="_blank">
                                            <img
                                                className="w-auto h-100"
                                                src="https://i.apteka24.ua/legitimnost/Frame3.png"
                                                width="610"
                                                height="546"
                                                alt=""
                                                title=""
                                            />
                                        </a>
                                    </div>

                                    <div className="license-page__documents">
                                        <p className="license-page__documents-title">
                                            {this.HTMLResource.license.complianceRequirements}
                                        </p>

                                        <Carousel
                                            config={this.carouselConfig}
                                            showBlur
                                            // items={this._getCertificates()}
                                            // preview={this._getCertificates()[0]}
                                            // clickOnThumb={this.props.clickOnGalleryThumb}
                                        >
                                            { this._renderCertificates() }
                                        </Carousel>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default License;
